// /frontend/src/config.js

const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "production" ? "/api" : "http://localhost:8000");

const WS_URL =
  process.env.REACT_APP_WS_URL ||
  (process.env.NODE_ENV === "production" ? window.location.origin.replace(/^http/, "ws") : "ws://localhost:8000");

export { API_BASE, WS_URL };
